import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import store from '../store/store';
import {router} from '../routes/router';
import { resetOldCookies } from '../utils/cookies';

function App() {
  resetOldCookies();

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;